import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Button from '../elements-buttons/Button';
import validateParkingForm from './forms/validateParkingForm';
import onSubmitParking from './forms/onSubmitParking';
import ParkingFields from './ParkingFields';
import SurveillanceFields from '../app-surveillance-info/SurveillanceFields';
import parkingInitialValues from './data/getInitialValues';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const ParkingForm = ({
  error,
  handleSubmit,
  parkingToggleFieldValue,
  surveillanceToggleFieldValue
}) => {
  return (
    <form className="flex-basis-100" onSubmit={handleSubmit}>
      <div className="set-up-form-container">
        <ParkingFields parkingToggleFieldValue={parkingToggleFieldValue} />
        <SurveillanceFields surveillanceToggleFieldValue={surveillanceToggleFieldValue} />
        <hr className="space-type-line-break"/>
        <div className="flex space-between">
          <Button
            category="primary"
            className="submit-cta"
            disabled={false}
            attributes={{
              'data-testing-id': 'edit-parking'
            }}
          >
            <FormattedMessage id="hosting.parking_form.button_text_done" defaultMessage="Done"/>
          </Button>
        </div>
      </div>
      <div className="text-danger text-small">{error}</div>
    </form>
  );
};

ParkingForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  parkingToggleFieldValue: PropTypes.string,
  surveillanceToggleFieldValue: PropTypes.string,
  intl: intlShape
};

const config = {
  form: 'EDIT_PARKING_FORM',
  validate: validateParkingForm,
  onSubmit: onSubmitParking
};

const selector = formValueSelector('EDIT_PARKING_FORM');

function mapStateToProps (state) {
  const parkingToggleFieldValue = selector(state, 'is_available');
  const surveillanceToggleFieldValue = selector(state, 'has_surveillance');

  const hasSurveillance = get(state, 'space.data.surveillance_info.has_surveillance', true).toString();
  const surveillanceDescription = get(state, 'space.data.surveillance_info.description', '');

  return {
    surveillanceToggleFieldValue,
    parkingToggleFieldValue,
    initialValues: {
      ...parkingInitialValues(state),
      has_surveillance: hasSurveillance,
      surveillance_description: surveillanceDescription
    }
  };
}

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(ParkingForm)));
